<template>
  <v-app>
    <div>
      <div class="container">
        <header class="codrops-header">
          <div class="codrops-links">
            <v-icon large color="green darken-2" @click.prevent="previousPage">
              mdi-arrow-left
            </v-icon>
            <v-icon large color="green darken-2">mdi-water</v-icon>
          </div>
          <h1>
            Paramètres Kiosk <strong> {{ shop.titleshop }} </strong>
            <span
              >Pour une création optimale, assurez-vous que tous les champs sont
              bien remplis.</span
            >
          </h1>

          <div class="colorsrange">
            <div
              class="alignColor"
              v-for="(color, key) in shop.design"
              @click.prevent="updateColor(color, key)"
            >
              <span class="namecolortype">{{ key }}</span>
              <div
                class="height-color"
                :style="{
                  position: 'relative',
                  width: '30px',
                  height: '30px',
                  'background-color': color
                }"
              ></div>
            </div>
          </div>
          <div class="colorpickergrad" v-show="toggleDiagran">
            <v-color-picker :mode.sync="colortype" v-model="currentColor">
            </v-color-picker>
            <strong>{{ currentKeyColor }} </strong>
            <strong @click.prevent="hideColorPicker">Fermer</strong>
          </div>
        </header>

        <div class="row"></div>

        <v-form>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="4"
                v-if="!uploadimage"
                v-show="shop.Logobusiness.length"
              >
                <v-btn
                  :loading="loading5"
                  :disabled="loading5"
                  color="blue-grey"
                  class="btn-close-image ma-2 white--text"
                  fab
                  @click="uploadimage = true"
                >
                  <v-icon dark>
                    mdi-cloud-upload
                  </v-icon>
                </v-btn>
                <v-img
                  max-height="600"
                  max-width="600"
                  :src="redirect + '/public/' + shop.Logobusiness"
                >
                </v-img>
              </v-col>
              <v-col
                cols="12"
                md="4"
                v-if="uploadimage"
                style="padding-top:50px"
              >
                <v-btn
                  :loading="loading5"
                  :disabled="loading5"
                  color="blue-grey"
                  class=" btn-close-image ma-2 white--text"
                  fab
                  @click="closePictureInput"
                >
                  <v-icon dark>
                    mdi-close
                  </v-icon>
                </v-btn>
                <picture-input
                  ref="pictureInput"
                  width="600"
                  height="600"
                  margin="16"
                  accept="image/jpeg,image/png"
                  size="10"
                  button-class="btn"
                  :custom-strings="{
                    upload: '<h1>Bummer!</h1>',
                    drag: 'Uploader le logo'
                  }"
                  id="profilpage"
                  @change="onChange"
                >
                </picture-input>
                <div class="text-center">
                  <v-btn
                    class="ma-2"
                    outlined
                    color="indigo"
                    @click.prevent="chargeImage"
                  >
                    charger l'image
                  </v-btn>
                </div>
              </v-col>

              <v-col cols="12" md="4" class="rakdf">
                <v-select
                  :items="['online', 'offline']"
                  v-model="shop.status"
                  label="Status"
                ></v-select>
                <div
                  class="height-color"
                  :style="{
                    position: 'relative',
                    width: '30px',
                    height: '30px',
                    'background-color': coloray[shop.status]
                  }"
                ></div>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="shop.subdomain"
                  label="subdomain"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="shop.titleshop"
                  label="titleshop"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="shop.email"
                  label="email"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="shop.tel"
                  label="tel"
                  required
                ></v-text-field>
              </v-col>

              <div class="col-12">
                <div class="form-floating mb-4">
                  <v-textarea v-model="shop.descriptionshop" color="teal">
                    <template v-slot:label>
                      <div>
                        Description de la boutique <small>(optional)</small>
                      </div>
                    </template>
                  </v-textarea>
                </div>
              </div>

              <v-col cols="12" md="12">
                <v-text-field
                  v-model="shop.message_end"
                  label="Notification Validation"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="12">
                <v-text-field
                  v-model="shop.message_start"
                  label="infos"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="shop.location.lat"
                  label="lat"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="shop.location.lng"
                  label="lng"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <div class="text-center">
            <v-btn
              text-center
              outlined
              color="indigo"
              @click.prevent="updateShop"
            >
              Mettre à jour
            </v-btn>
          </div>
        </v-form>

        <v-container>
          <v-row>
            <v-col
              v-for="n in shop.articles.length"
              :key="shop.articles[n - 1]['id']"
              cols="12"
              sm="6"
              md="4"
            >
              <single-article
                :ref="'article_' + shop.articles[n - 1]['id']"
                @getbackitems="getbackitemsFucton"
                @maxamountnotif="maxamountnotifFucton"
                @showmedescription="editforupdate"
                :current_quantity="0"
                :details="shop.articles[n - 1]"
                md="6"
                :key="shop.articles[n - 1]['id']"
                :redirect="redirect"
                :colorinfos="shop.design"
              >
              </single-article>
              <hr />
              <div></div>
            </v-col>
            <v-col cols="12" sm="6" md="4" @click.prevent="addNewarticle">
              <div class="v-image v-responsive grey lighten-2 theme--light">
                <div
                  class="v-responsive__sizer"
                  style="padding-bottom: 100%;"
                ></div>
                <div
                  class="v-image__image v-image__image--cover"
                  style="background-color: #e7ecf4; background-position: center center;"
                ></div>
                <!---->
                <div class="v-responsive__content">
                  <v-icon class="iconar"> mdi-plus </v-icon>
                </div>
              </div>
            </v-col>



            <edit-article
              :typeaction="typeaction"
              :dialogedition="dialogEdition"
              :shopid="shop.idshop"
              :key="'rass-'+keypair"
              :indexarticle="shop.articles.length"
              @closedialog="closeEdition"
              @errormessage="showError"
              :toupdate="element_update"
              @successCreation="articleCreated"
              @successUpdate="articleUpdated"
              :redirect="redirect"
            ></edit-article>
          </v-row>
        </v-container>
        <v-spacer></v-spacer>

        <v-snackbar v-model="snackbarupdate" :timeout="timeoutSnackbarUpdate">
          {{ text_snackbarupdate }}

          <template v-slot:action="{ attrs }">
            <v-btn
              color="blue"
              text
              v-bind="attrs"
              @click="snackbarupdate = false"
            >
              fermer
            </v-btn>
          </template>
        </v-snackbar>
      </div>


    </div>
  </v-app>
</template>

<style scoped>
@import url("https://mojay.pro/assets/css/plugins.css");

@import url("https://mojay.pro/assets/css/style.css");

@import "../assets/css/createshop.css";
</style>

<script>
import PictureInput from "vue-picture-input";

import axios from "axios";

import Article from "./pieces/article.vue";

import DescriptionArticle from "./pieces/descriptionarticle.vue";

import { mixin as onClickOutside } from "vue-on-click-outside";

import EditArticle from "./pieces/editarticle.vue";

export default {
  title: "SettingShop",
  mixins: [onClickOutside],
  props: {},

  computed: {},

  data() {
    return {
      redirect: "https://kiosk.ojay.delivery/test",
      shop: {},
      loading5: false,
      uploadimage: false,
      colortype: "hexa",
      currentColor: "#FFFFFFFF",
      currentKeyColor: "backgroundColor",
      toggleDiagran: false,
      coloray: {
        online: "#4caf50",
        offline: "#f44336"
      },
      snackbarupdate: false,
      displayedition: false,
      timeoutSnackbarUpdate: 10000,
      text_snackbarupdate: "",
      articleToDescrip: "",
      dialogEdition: false,
      typeaction: "",
      element_update: {},
      keypair: 0
    };
  },

  components: {
    PictureInput,
    "single-article": Article,
    "description-article": DescriptionArticle,
    "edit-article": EditArticle
  },

  mounted() {
    this.getShopInfo();
  },

  watch: {
    currentColor(newval) {
      console.log("currentColor(newval) ==> ", newval);
      let key = this.currentKeyColor;
      this.shop.design[key] = newval;
    }
  },

  methods: {
    showError(msg) {
      this.snackbarupdate = true;
      this.text_snackbarupdate = msg;
    },
    maxamountnotifFucton(){

    },
    getbackitemsFucton(){},
    chargeImage() {
      let Oldthis = this;
      let formData = new FormData();
      formData.append(
        "Logobusiness",
        document.getElementById("profilpage").files[0]
      );

      formData.append("idshop", this.shop.idshop);

      let pathorder = this.redirect + `/update/shop/image/${this.shop._id}`;

      axios
        .post(pathorder, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function(response) {
          console.log("postReservation ==>", response.data);

          if (response.data.hasOwnProperty("acknowledged")) {
            Oldthis.snackbarupdate = true;
            Oldthis.text_snackbarupdate = "image changée avec succès";
            Oldthis.shop.Logobusiness = response.data.Logobusiness;
            //this.errorHtml = this.prettyPrint(response.data);
          }
        })
        .catch(error => {
          console.log("catch ==> ", error);
          this.errorHtml = error.body;
        });

      this.$http
        .post(pathorder, {
          image: this.shop
        })
        .then(
          function(response) {
            console.log("response update =>", response.data);
            if (response.data.hasOwnProperty("acknowledged")) {
              Oldthis.snackbarupdate = true;
              Oldthis.text_snackbarupdate =
                "Modification effectuée avec succès";
            }
          },
          function(error) {
            console.log("error updating", error);
            Oldthis.snackbarupdate = true;
            Oldthis.text_snackbarupdate =
              "erreur survenu pendant la modification";
          }
        );
    },
    closePictureInput() {
      console.log("closePictureInput");
      this.uploadimage = false;
      console.log(" this.uploadimage  ===> ", this.uploadimage);
    },
    changeImage() {
      this.shop.Logobusiness = " ";
    },
    refreshPage() {
      console.log('refresh page')
      this.$forceUpdate();
      window.location.href = window.location.href;
     },
    closeEdition(isclosed) {
      console.log("we are in closeEdition", isclosed);
      if (isclosed) {
        this.dialogEdition = false;
      }
    },
    editforupdate(informations) {
      console.log("les informations a éditer", informations);
      this.element_update = informations;
      this.typeaction = "update";
      this.dialogEdition = true;
      this.displayedition = true;
    },
    articleCreated(article) {
      //console.log("articleCreated");

      this.shop.articles.push(article);
      this.snackbarupdate = true;
      this.text_snackbarupdate = "nouvel article ajouté avec succès";
      this.displayedition = false;
      this.keypair += 1 ;
      this.refreshPage();
    },
    articleUpdated(article) {
      this.shop.articles.forEach((art, key) => {
        if (art.id == article.id) {
          console.log("on a un MATCH");
          console.log(" this.shop.articles[key]", this.shop.articles[key]);
          console.log(" articles  ", article);

          this.shop.articles[key] = article;
          this.snackbarupdate = true;
          this.text_snackbarupdate = " article modifié avec succès";
          this.displayedition = false;
          this.keypair += 1 ;
          this.refreshPage();

        }
      });
    },
    addNewarticle() {
      console.log("addNewarticle");
      this.dialogEdition = true;
      this.typeaction = "creation";
      this.displayedition = true;
    },
    ShowTheDescription(article) {
      this.articleToDescrip = article;
      console.log("ShowTheDescription ===>", article);
    },
    previousPage() {
      console.log("previousPage ::: ");
      this.$router.push({
        name: "createshop"
      });
    },
    onChange(image) {
      console.log("New picture selected!");
      if (image) {
        console.log("Picture loaded.");
        this.shop.Logobusiness = image;
      } else {
        console.log("FileReader API not supported: use the <form>, Luke!");
      }
    },
    updateImageShop() {
      let Oldthis = this;
      let formData = new FormData();
      formData.append("Logobusiness", value);
    },
    updateShop() {
      console.log(" <== updateShop ==> ");
      let pathorder = this.redirect + `/update/shop/${this.shop._id}`;
      let Oldthis = this;
      this.$http
        .post(pathorder, {
          shop: this.shop
        })
        .then(
          function(response) {
            console.log("response update =>", response.data);
            if (response.data.hasOwnProperty("acknowledged")) {
              Oldthis.snackbarupdate = true;
              Oldthis.text_snackbarupdate =
                "Modification effectuée avec succès";
            }
          },
          function(error) {
            console.log("error updating", error);
            Oldthis.snackbarupdate = true;
            Oldthis.text_snackbarupdate =
              "erreur survenu pendant la modification";
          }
        );
    },
    getShopInfo() {
      console.log("getShopInfo ==> ", this.$route.params.idshop);
      let fullpath =
        this.redirect + `/get/infos/shop/${this.$route.params.idshop}`;

      console.log("fullpath ==>", fullpath);

      this.$http.get(fullpath).then(
        function(response) {
          console.log("response=>", response);
          if (response.data.shop) {
            this.shop = response.data.shop;
          }
        },
        function(error) {}
      );
    },
    hideColorPicker() {
      console.log("hideColorPicker");
      //this.toggleDiagran=false;
      if (this.toggleDiagran) {
        console.log("la condition est bien verifée", this.toggleDiagran);
        this.toggleDiagran = false;
      }
    },
    updateColor(color, title) {
      console.log("updateColor ==> ");
      console.log("color ==> ", color);
      console.log("picker ==> ", title);
      this.currentColor = color;
      this.currentKeyColor = title;
      this.toggleDiagran = true;
      console.log("toggleDiagran ==> ", this.toggleDiagran);
    },

    replacer(match, pIndent, pKey, pVal, pEnd) {
      var key = `<span class="jsonkey" @click.prevent="clickey()" style="color: #ffc600;font-weight:bold;font-size:17px">`;
      var val = `<span class="json-value">`;
      var str = `<span class="json-string">`;

      var r = pIndent || "";
      if (pKey) r = r + key + pKey.replace(/[": ]/g, "") + "</span>: ";
      if (pVal) r = r + (pVal[0] == '"' ? str : val) + pVal + "</span>";

      //console.log('the finale r ==> ', r + (pEnd || ''));
      return r + (pEnd || "");
    },

    prettyPrint(obj) {
      var jsonLine = /^( *)("[\w]+": )?("[^"]*"|[\w.+-]*)?([,[{])?$/gm;
      return JSON.stringify(obj, null, 3)
        .replace(/&/g, "&amp;")
        .replace(/\\"/g, "&quot;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(jsonLine, this.replacer);
    }
  }
};
</script>
<style scoped>
.colorsrange {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.namecolortype {
  margin-right: 10px;
}
.alignColor {
  border: 50% solid transparent;
  z-index: 3;
  display: flex;
  padding: 5px 5px 5px 8px;
  border-radius: 5px;
  background-color: #e7ecf4;
}

.height-color {
  border: 1px solid transparent;
  border-radius: 100%;
}
.colorpickergrad {
  width: 305px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid #e7ecf4;
  z-index: 5;
  margin-left: 50%;
  transform: translateX(-50%);
  margin-top: 60px;
}

.rakdf {
  display: flex;
  flex-direction: row;
}

.picture-rack {
  position: relative;
  background-color: #e7ecf4;
  height: 250px;
  width: 100%;
  text-align: center;
}

.iconar {
  position: absolute;
  font-size: 45px;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
}

.btn-close-image {
  position: absolute;
  top: 0;
  z-index: 10000;
}
</style>



// WEBPACK FOOTER //
// src/components/SettingShop.vue